import { apiProxyRequest } from "Api/apiProxyRequest";

import type { ProjectQuote, ProjectQuoteParameters } from "../types";

export const getProjectQuote = ({
  projectId,
  parameters = {}
}: {
  projectId: string;
  parameters?: ProjectQuoteParameters;
}) => {
  const query = new URLSearchParams();
  // Empty strings are meaningful (they quote an addon as none/default), so
  // only undefined values are dropped.
  Object.entries(parameters).forEach(([key, value]) => {
    if (value !== undefined) query.set(key, String(value));
  });
  const queryString = query.toString();

  return apiProxyRequest<ProjectQuote>(
    `/billing/quote-project/${projectId}${queryString ? `?${queryString}` : ""}`
  );
};
